import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(() => {
    // Initialize from localStorage on mount
    const adminData = localStorage.getItem('adminData');
    const adminToken = localStorage.getItem('adminToken');
    if (adminToken && adminData) {
      try {
        api.defaults.headers.common['Authorization'] = `Bearer ${adminToken}`;
        return JSON.parse(adminData);
      } catch (e) {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminData');
        return null;
      }
    }
    return null;
  });
  
  const [scanner, setScanner] = useState(() => {
    // Initialize from localStorage on mount
    const scannerData = localStorage.getItem('scannerData');
    if (scannerData) {
      try {
        return JSON.parse(scannerData);
      } catch (e) {
        localStorage.removeItem('scannerToken');
        localStorage.removeItem('scannerData');
        return null;
      }
    }
    return null;
  });
  
  const [loading, setLoading] = useState(false);

  const loginAdmin = async (email, password) => {
    const response = await api.post('/admin/login', { email, password });
    const { token, admin: adminData } = response.data;
    
    localStorage.setItem('adminToken', token);
    localStorage.setItem('adminData', JSON.stringify(adminData));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    setAdmin(adminData);
    return adminData;
  };

  const registerAdmin = async (email, password, fullName) => {
    const response = await api.post('/admin/register', {
      email,
      password,
      full_name: fullName
    });
    const { token, admin: adminData } = response.data;
    
    localStorage.setItem('adminToken', token);
    localStorage.setItem('adminData', JSON.stringify(adminData));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    setAdmin(adminData);
    return adminData;
  };

  const logoutAdmin = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminData');
    delete api.defaults.headers.common['Authorization'];
    setAdmin(null);
  };

  const loginScanner = async (campaignId, username, password) => {
    const response = await api.post('/dashboard/login', {
      campaign_id: campaignId,
      username,
      password
    });
    const { token, dashboard } = response.data;
    
    localStorage.setItem('scannerToken', token);
    localStorage.setItem('scannerData', JSON.stringify(dashboard));
    
    setScanner(dashboard);
    return dashboard;
  };

  const logoutScanner = () => {
    localStorage.removeItem('scannerToken');
    localStorage.removeItem('scannerData');
    setScanner(null);
  };

  return (
    <AuthContext.Provider value={{
      admin,
      scanner,
      loading,
      loginAdmin,
      registerAdmin,
      logoutAdmin,
      loginScanner,
      logoutScanner
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
